import { t as toPropertyKey } from './toPropertyKey-ae5ee4b0.js';

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

export { _defineProperty as _ };
//# sourceMappingURL=defineProperty-2d1aa32d.js.map
